<template>
  <router-view/>
</template>
<style>
@import "./assets/app.css";
</style>
